import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import s from './MarketSnapshot.scss';

const fetchData = (url, setterFn, isMobile) =>
  makeRequest
    .get(url, { isMobile })
    .then(data => {
      if (data) {
        const response = data.data.replace('marketlivedata([', '');
        const sliceData = response.slice(0, -4);
        const finalData = JSON.parse(sliceData);
        setterFn(finalData);
      }
    })
    .catch(err => console.log(err));

// Gold, Sliver, Nifty, Sensex widget
const RenderHtml = ({ marketData }) => {
  if (typeof marketData === 'object' && Object.keys(marketData).length !== 0) {
    const allowed = ['nifty', 'sensex', 'gold', 'silver'];
    Object.keys(marketData)
      .filter(key => !allowed.includes(key))
      .forEach(key => delete marketData[key]);
    const orderedData = [];
    allowed.forEach(lkey => {
      if (typeof marketData[lkey] !== 'undefined') {
        if (lkey === 'nifty') {
          marketData[lkey].IndexName = 'NIFTY';
        }
        if (lkey === 'silver') {
          marketData[lkey].PriceQuotationUnit = '1 KG';
        }
        orderedData.push(marketData[lkey]);
      }
    });

    return (
      <>
        {orderedData.map(data => {
          let profitClass;
          profitClass = data.NetChange > 0 ? s.positive : s.negative;
          if (Math.abs(data.NetChange) === 0) {
            profitClass = s.nochange;
            data.NetChange = 'No Change';
          } else {
            data.NetChange = Math.abs(data.NetChange);
          }
          return (
            <div className={s.card}>
              <div className={s.cardName}>
                {data.IndexName || data.Symbol}

                {data.Symbol && (
                  <span>( &#x20b9;/{`${data.PriceQuotationUnit}`})</span>
                )}
              </div>
              <div className={s.cardVal}>
                {data.CurrentIndexValue || data.LastTradedPrice}
              </div>
              <div className={`${s.cardstatus} ${profitClass}`}>
                {data.NetChange}
              </div>
            </div>
          );
        })}
      </>
    );
  }
  return false;
};

const MarketSnapshot = ({ data, isMobile }) => {
  const [marketData, setData] = useState(null);
  const dataURL = data.dataUrl;

  useEffect(() => {
    fetchData(dataURL, setData, isMobile);
  }, []);

  return (
    <div className={s.mrktWidget}>
      <div className={s.heading}>
        {data.name || 'Market Snapshot'}
        {data.showstatus === 'on' && (
          <span>
            {marketData !== null &&
            marketData.marketstatus !== undefined &&
            marketData.marketstatus.currentMarketStatus === 'Live'
              ? '(OPEN)'
              : '(CLOSE)'}
          </span>
        )}
      </div>
      <div className={s.cardWrapper}>
        {marketData !== null ? (
          <RenderHtml marketData={marketData} />
        ) : (
          'Loading...'
        )}
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});
MarketSnapshot.propTypes = {
  data: PropTypes.objectOf({}),
  isMobile: PropTypes.bool,
};
MarketSnapshot.defaultProps = {
  data: {},
  isMobile: false,
};

export default React.memo(connect(mapStateToProps)(MarketSnapshot));
